import {
  FiUsers as UsersIcon,
  FiUser as UserIcon,
  FiActivity as ProtocolIcon,
  FiCpu as DeviceIcon,
  FiSettings as SettingsIcon,
  FiSliders as FeedbackResponseIcon,
  FiClipboard as QuestionnaireIcon,
  FiBarChart2 as AssessmentIcon,
  FiLayers as SessionIcon,
} from 'react-icons/fi';

export const rolesPermission = (user, allowedRoles) => {
  // allowedRoles is a number argument that grabs the each item on its corresponding index, ex. 13 will grab ['AccountAdmin', 'Coach']
  // you never need to add 0 as the code is built to check for SuperUser roles always

  // if no groups on the user object return false
  if (!user || !Array.isArray(user.groups)) {
    return false;
  }

  if (user.groups.some((item) => item.name === 'SuperUser')) {
    return true;
  }

  const permissedRoles = allowedRoles.toString().split('').map(Number);
  let roles = ['SuperUser', 'AccountAdmin', 'Therapist', 'Coach'];
  let tempRoles = [];

  permissedRoles.map((num) => {
    tempRoles.push(roles[num]);
  });

  if (user.groups.some((item) => tempRoles.includes(item.name))) {
    return true;
  }

  return false;
};

export const protocolPermission = ({
  user,
  data,
  isQuestionnaire = false,
}: {
  user: any;
  data: any;
  isQuestionnaire?: boolean;
}) => {
  // if no groups on the user object return false
  if (!user || !Array.isArray(user.groups)) {
    return false;
  }

  if (user.groups.some((item) => item.name === 'SuperUser')) {
    return true;
  }

  if (user.userId === data?.therapistId) {
    return true;
  }

  if (isQuestionnaire && user.userId === data.userId) {
    return true;
  }

  return false;
};

export const getLinks = (user) => {
  // if no groups on the user object return empty
  if (!user || !Array.isArray(user.groups)) {
    return [];
  }

  const links = [
    {
      title: 'Clients',
      icon: UsersIcon,
      href: '/app/clients',
    },
    {
      title: 'Operators',
      icon: UserIcon,
      href: '/app/users',
      new: true,
    },
    {
      title: 'Questionnaires',
      icon: QuestionnaireIcon,
      href: '/app/questionnaires',
    },
    {
      title: 'Track Devices',
      icon: DeviceIcon,
      href: '/app/devices',
    },
    {
      title: 'Feedback Responses',
      icon: FeedbackResponseIcon,
      href: '/app/feedbackresponses',
    },
    {
      title: 'Protocols',
      icon: ProtocolIcon,
      href: '/app/protocols',
    },
    {
      title: 'Assessments',
      icon: AssessmentIcon,
      href: '/app/assessments',
    },
    {
      title: 'Sessions',
      icon: SessionIcon,
      href: '/app/sessions',
    },
    {
      title: 'Settings',
      icon: SettingsIcon,
      href: '/app/account',
    },
  ];

  if (user.groups.some((item) => item.name === 'SuperUser')) {
    return links;
  }

  let tempArr = [];
  const roleLinks = {
    AccountAdmin: ['Clients', 'Operators', 'Devices', 'Settings'],
    Therapist: [
      'Clients',
      'Questionnaires',
      'Track Devices',
      'Feedback Responses',
      'Protocols',
      'Assessments',
      'Sessions',
      'Settings',
    ],
    Coach: [
      'Clients',
      'Questionnaires',
      'Track Devices',
      'Feedback Responses',
      'Protocols',
      'Assessments',
      'Sessions',
      'Settings',
    ],
  };

  user.groups.map((item) => {
    tempArr.push(roleLinks[item.name]);
  });

  // Flatten and reduce to unique items
  const uniqueLinks = Array.from(new Set(tempArr.flat()));

  // Build linksArr in the order of the original links array, only including those in uniqueLinks
  const linksArr = links.filter((link) => uniqueLinks.includes(link.title));

  return linksArr;
};

export const tagPermission = (user, tag) => {
  if (tag.therapistId === 'NMI' || tag.therapistId === 'TrueBearing') {
    return false;
  }

  if (user.groups.some((item) => item.name === 'SuperUser')) return true;

  if (user.userId === tag.therapistId) return true;

  return false;
};
